function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _instanceof(left, right) {
    if (right != null && typeof Symbol !== "undefined" && right[Symbol.hasInstance]) {
        return !!right[Symbol.hasInstance](left);
    } else {
        return left instanceof right;
    }
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
import React, { useCallback, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { ReactSVG } from 'react-svg';
import { Button } from '../../components/button';
import Page from '../../components/page/Page';
import { OpenBookmarkRejectedError } from '../../utilities/bookmark';
import { profileSelectors } from '../../redux/selectors/profile';
import text from '../../text';
import { captureError } from '../../utilities/error';
import { useRedirect } from '../../hooks/useRedirect';
import useUrlParam from '../../mp/hooks/useUrlParam';
import { useCheckJobAccessQuery, useCheckProjectAccessQuery, useOpenBookmarkQuery, useRequestAccessMutation } from '../../redux/rtk';
import useSearchParam from '../../hooks/useSearchParam';
var RequestAccess = function(param) {
    var shareToken = param.shareToken, projectId = param.projectId, jobId = param.jobId;
    var redirect = useRedirect();
    var page = useSearchParam('page');
    var user = useSelector(profileSelectors.getUserProfile);
    var _useRequestAccessMutation = _sliced_to_array(useRequestAccessMutation(), 2), requestAccess = _useRequestAccessMutation[0], requestAccessState = _useRequestAccessMutation[1];
    var checkJobAccessState = useCheckJobAccessQuery({
        jobId: jobId
    }, {
        skip: !jobId
    });
    var checkProjectAccessState = useCheckProjectAccessQuery({
        projectId: projectId
    }, {
        skip: !projectId
    });
    var openBookmarkState = useOpenBookmarkQuery({
        shareToken: shareToken,
        redirectToRequestAccess: false
    }, {
        skip: !shareToken
    });
    var _useState = _sliced_to_array(useState(false), 2), isRejected = _useState[0], setIsRejected = _useState[1]; // was access denied?
    var handleRequestAccessClicked = useCallback(/*#__PURE__*/ _async_to_generator(function() {
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        requestAccess({
                            shareToken: shareToken,
                            projectId: projectId,
                            jobId: jobId
                        })
                    ];
                case 1:
                    _state.sent();
                    return [
                        2
                    ];
            }
        });
    }), [
        requestAccess,
        shareToken,
        projectId,
        jobId
    ]);
    useEffect(function() {
        var error = openBookmarkState.error;
        if (error) captureError(error);
    }, [
        openBookmarkState.error
    ]);
    useEffect(function() {
        var data = openBookmarkState.data;
        if (data) {
            if (data.isRejected) {
                setIsRejected(true);
            } else if (data.redirectUrl) {
                redirect.push(data.redirectUrl);
            }
        }
    }, [
        openBookmarkState.data,
        redirect
    ]);
    useEffect(function() {
        var err = openBookmarkState.error;
        if (!err) return;
        if (_instanceof(err, OpenBookmarkRejectedError)) {
            setIsRejected(true);
        } else {
            captureError(err);
        }
    }, [
        openBookmarkState.error
    ]);
    var handleCheckAccess = useCallback(function(userProject) {
        if (userProject.invite_status === 'rejected') {
            setIsRejected(true);
        } else if (userProject.invite_status === 'accepted' && page) {
            redirect.push(page);
        }
    }, [
        page,
        redirect
    ]);
    useEffect(function() {
        if (checkJobAccessState.data) handleCheckAccess(checkJobAccessState.data);
    }, [
        checkJobAccessState.data,
        handleCheckAccess
    ]);
    useEffect(function() {
        if (checkJobAccessState.error) captureError(checkJobAccessState.error);
    }, [
        checkJobAccessState.error
    ]);
    useEffect(function() {
        if (checkProjectAccessState.data) handleCheckAccess(checkProjectAccessState.data);
    }, [
        checkProjectAccessState.data,
        handleCheckAccess,
        page,
        redirect
    ]);
    useEffect(function() {
        if (checkProjectAccessState.error) captureError(checkProjectAccessState.error);
    }, [
        checkProjectAccessState.error
    ]);
    return(// @ts-expect-error bad typing
    /*#__PURE__*/ React.createElement(Page, {
        title: "Request Access"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "request-access__container"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "request-access__text-content"
    }, isRejected ? /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement("h1", null, text('accessDenied')), /*#__PURE__*/ React.createElement("p", {
        className: "request-access__fail"
    }, text('accessDeniedDescription'))) : /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement("h1", null, text('youNeedAccess')), !requestAccessState.isLoading && !requestAccessState.error && requestAccessState.isSuccess ? /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement("p", {
        className: "request-access__success mb-lg"
    }, text('accessRequestSent'), /*#__PURE__*/ React.createElement("br", null), text('accessRequestEmail')), user ? /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement("p", {
        className: "mb-md"
    }, text('profileRequestingAccess')), /*#__PURE__*/ React.createElement("p", null, user.full_name, /*#__PURE__*/ React.createElement("br", null), user.email)) : null) : /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement("p", null, text('youNeedToBeInvited')), /*#__PURE__*/ React.createElement(Button, {
        onClick: handleRequestAccessClicked,
        loading: requestAccessState.isLoading,
        className: "request-access__button"
    }, text('requestAccess'))))), /*#__PURE__*/ React.createElement(ReactSVG, {
        src: "/public/img/request-access.svg",
        className: "request-access__img"
    }))));
};
var RequestAccessShareLink = function() {
    var shareToken = useUrlParam('shareToken');
    return /*#__PURE__*/ React.createElement(RequestAccess, {
        shareToken: shareToken
    });
};
var RequestAccessProject = function() {
    var projectId = useUrlParam('projectId', {
        int: true
    });
    return /*#__PURE__*/ React.createElement(RequestAccess, {
        projectId: projectId
    });
};
var RequestAccessJob = function() {
    var jobId = useUrlParam('jobId', {
        int: true
    });
    return /*#__PURE__*/ React.createElement(RequestAccess, {
        jobId: jobId
    });
};
var RequestAccessPage = {
    ShareLink: RequestAccessShareLink,
    Project: RequestAccessProject,
    Job: RequestAccessJob
};
export default RequestAccessPage;
